<template>  
  <button class="btn btn-primary my-2 my-sm-0" type="submit" @click.prevent="action">
    <fa-icon :icon="icon"/>
    {{ label }}
  </button>
</template>

<script>
export default {
  name: 'disconnect',
  props: ['device'],
  data () {
    return {
      connected: false,
      label: 'Disconnect',
      icon: 'unlink'
    }
  },
  methods: {
    action (e) {
      e.target.blur()

      this.device.disconnect()
    }
  }
}
</script>

<style>
</style>




// WEBPACK FOOTER //
// src/components/controls/Disconnect.vue